export default "/images/topdanmark-logo-150-2021.avif?bf6970d47c12af8a7c412fed38278e3e";